import React from "react";
import { Button, Modal } from "reactstrap";
import { useDispatch } from "react-redux";
import CustomButtom from "../../Button";
import Select from "../../SearchDropDown";
import TextInput from "../..//TextInput";
import { getOrderStatuses } from "reducers/order";
import PropTypes from "prop-types";

const ChangeStatusModal = ({ open, onClose, loading, onConfirm }) => {
  const dispatch = useDispatch();
  const [statusList, setStatusList] = React.useState([]);
  const [remark, setRemark] = React.useState("");
  const [status, setStatus] = React.useState(null);
  /**
   * Fetch order status
   */
  const getAllOrderStatus = async () => {
    const res = await dispatch(getOrderStatuses());
    const list = res.map((option) => ({
      label: option.status,
      value: option.code
    }));
    setStatusList(list);
  };

  React.useEffect(() => {
    getAllOrderStatus();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = () => {
    onConfirm(status[0].value, remark);
    setRemark("");
    setStatus(null);
  };

  return (
    <Modal
      zIndex={2000}
      centered
      isOpen={open}
      toggle={loading ? null : onClose}>
      <div className="text-center p-5">
        <div className="pt-4">
          <Select
            multi={false}
            placeholder="Select Status"
            options={statusList}
            onChange={setStatus}
            style={{ borderRadius: "5px", height: "45px" }}
          />
          <TextInput
            placeholder="Enter Remark"
            onChange={(e) => setRemark(e.target.value)}
          />
          <Button
            onClick={loading ? null : onClose}
            color="neutral-secondary"
            className="btn-pill mx-1">
            <span className="btn-wrapper--label">Cancel</span>
          </Button>
          <CustomButtom
            onClick={handleSubmit}
            disabled={!status || !remark || loading}
            label={loading ? "Submitting..." : "Submit"}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ChangeStatusModal;

ChangeStatusModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  confirmText: PropTypes.string,
  subText: PropTypes.string,
  onConfirm: PropTypes.func,
  icon: PropTypes.array
};
